// src/services/api.ts
import axios from "axios";
import useAuth from "../context/AuthContext";
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/api",
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token && config.headers) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;
